const MAIN_SCRIPT_PATTERN = /\/static\/js\/main\.([a-f0-9]+)\.js$/;

export const extractMainHash = (src) => {
    const match = MAIN_SCRIPT_PATTERN.exec(src || "")
    return match ? match[1] : null
}

export const getRunningVersion = () => {
    const script = Array.from(document.querySelectorAll("script[src]"))
        .find(element => extractMainHash(element.getAttribute("src")))

    return script ? extractMainHash(script.getAttribute("src")) : null
}

// index.html et asset-manifest.json sont servis sans Cache-Control : on force la revalidation pour voir le vrai build en ligne.
export const fetchDeployedVersion = async () => {
    const response = await fetch(`/asset-manifest.json?t=${Date.now()}`, {cache: "no-store"})
    if (!response.ok) {
        return null
    }

    const manifest = await response.json()
    return extractMainHash(manifest.files && manifest.files["main.js"])
}
